import React, { useEffect, useState } from "react"

import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"

import Overlay from "../../atoms/overlay"
import Modal from "../../molecules/modal"

const SubscribePrompt = ({ pageType, custom }) => {
  const { allSanityDictionary } = useStaticQuery(graphql`
    {
      allSanityDictionary {
        nodes {
          key {
            current
          }
          value
        }
      }
    }
  `)
  const [activeModal, setActiveModal] = useState(false)

  const conditions = () =>
    !localStorage.getItem("beenPromptedSubscribe") &&
    Object.keys(localStorage).filter((key) => key.startsWith("subscribed_"))
      .length === 0 &&
    !window.location.pathname.includes("contest/") &&
    !window.location.pathname.includes("bracket-challenge/") &&
    !window.location.pathname.includes("account/") &&
    pageType !== "subscribe"

  const openModal = () => {
    if (conditions()) {
      setActiveModal(true)
      document.body.classList.add("disableScroll")
    }
  }

  const closeModal = (e) => {
    e.preventDefault()
    if (e.target === e.currentTarget) {
      document.body.classList.remove("disableScroll")
      localStorage.setItem("beenPromptedSubscribe", true)
      setActiveModal(false)
    }
  }
  let lastPosition
  let newPosition
  let timer

  const myScroll = (() => {
    let delta
    const delay = 50

    function clear() {
      lastPosition = null
      delta = 0
    }

    clear()
    return () => {
      newPosition = window.scrollY
      if (lastPosition != null) {
        delta = newPosition - lastPosition
      }

      lastPosition = newPosition
      clearTimeout(timer)

      timer = setTimeout(clear, delay)

      return delta
    }
  })()

  const myScrollSpeedFunction = () => {
    const delta = myScroll()
    if (delta < -80 && window.innerWidth <= 800) {
      openModal()
    }
  }

  useEffect(() => {
    document.addEventListener("mouseleave", openModal)
    document.addEventListener("scroll", myScrollSpeedFunction)
  }, [])

  return (
    <Overlay trigger={activeModal} event={closeModal} custom={custom}>
      <Modal
        closeModal={closeModal}
        message={
          allSanityDictionary.nodes.find(
            (item) => item.key.current === "subscribe_prompt"
          )?.value
        }
        yesUrl="/subscribe"
        yesText={
          allSanityDictionary.nodes.find(
            (item) => item.key.current === "subscribe"
          )?.value
        }
      />
    </Overlay>
  )
}

export default SubscribePrompt

SubscribePrompt.propTypes = {
  pageType: PropTypes.string.isRequired,
  custom: PropTypes.bool.isRequired,
}
